import Vue from "vue";
import App from "./App.vue";
import router from "./router";
// @ts-ignore
import VueFormGenerator from 'vue-form-generator';
import store from "./store";


import {BootstrapVue, VBModal} from 'bootstrap-vue'
import {formatDate, formatDateTime, formatPrice} from "@/utils";
import FormCheckbox from './components/form/fields/FormCheckbox.vue';
import FormPassword from './components/form/fields/FormPassword.vue';
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {library} from "@fortawesome/fontawesome-svg-core";
import {
    faExternalLinkAlt,
    faAngleDown,
    faChartLine,
    faWallet,
    faTimes,
    faPen,
    faInfoCircle,
    faAngleLeft,
    faAngleRight,
    faPaperclip,
    faCheck,
    faBars,
    faEye,
    faEyeSlash,
    faExclamation,
    faFilePdf,
    faAngleUp,
    faDownload,
    faFile,
    faPhone,
    faMapMarkerAlt, faPassport, faIdCard, faSpinner, faCog, faLock, faCircle,
} from "@fortawesome/free-solid-svg-icons";
import {faEnvelope, faListAlt, faFileAlt} from "@fortawesome/free-regular-svg-icons";
library.add(faExternalLinkAlt, faAngleDown, faEnvelope, faWallet, faListAlt, faWallet, faTimes, faInfoCircle, faPen);
library.add(faChartLine, faFileAlt, faAngleLeft, faAngleRight, faPaperclip, faCheck, faBars, faEye, faEyeSlash, faExclamation, faFilePdf);
library.add(faAngleUp, faDownload, faFile, faPhone, faMapMarkerAlt, faPassport, faIdCard, faSpinner, faCog, faLock, faCircle);

Vue.use(BootstrapVue);
Vue.use(VueFormGenerator);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("field-customCheckbox", FormCheckbox);
Vue.component("field-titanPassword", FormPassword);
Vue.directive('b-modal', VBModal);

Vue.config.productionTip = false;



// eslint-disable-next-line @typescript-eslint/no-var-requires
const companyTexts = require('./assets/texts/' + process.env.VUE_APP_TEXTS_FILE);
// eslint-disable-next-line @typescript-eslint/no-var-requires
const variablesStylesheet = require('./assets/styles/' + process.env.VUE_APP_SCSS_VARIABLES_GRAPHS);

function __getCompanyText(key: any) {
    return companyTexts[key];
}

function __getGraphsCssVariables(key: any) {
    return variablesStylesheet[key];
}

Vue.mixin({
    methods: {
        getCompanyText(key) {
            return __getCompanyText(key);
        },
        getLogoUrl() {
            return "images/" + process.env.VUE_APP_LOGO_FILE;
        },
        getGraphsCssVariables(key) {
            return __getGraphsCssVariables(key);
        }
    }
});

const app = new Vue({
    router,
    store,
    render: h => h(App),
}).$mount("#app");

Vue.filter("number", (number: number, minimumFractionDigits: number | null = 2) => {
    return formatPrice(number, minimumFractionDigits);
});
Vue.filter("price", (number: number) => {
    return formatPrice(number, 2);
});
Vue.filter('date', (date: any) => {
    return formatDate(date);
});
Vue.filter('dateTime', (date: any) => {
    return formatDateTime(date);
});
Vue.filter('truncate', (text: string, length: number, clamp: string) => {
    clamp = clamp || '...';
    return text.length > length ? text.slice(0, length) + clamp : text;
});

Vue.prototype.$log = console.log;

const res = VueFormGenerator.validators.resources;
res.fieldIsRequired = "Toto pole je povinné!";
res.invalidFormat = "Neplatný formát!";
res.numberTooSmall = "Toto číslo je príliš malé! Minimálne: {0}";
res.numberTooBig = "Toto číslo je príliš veľké! Maximum: {0}";
res.invalidNumber = "Zlé číslo";
res.invalidInteger = "Táto hodnota nie je celé číslo";
res.textTooSmall = "Text je krátky! Aktuálne: {0}, Minimálne: {1}";
res.textTooBig = "Text je príliš dlhý! Aktuálny: {0}, Maximálny: {1}";
res.thisNotText = "Zadajte text!";
res.thisNotArray = "Zadané hodnotan nie je pole.";
res.selectMinItems = "Vyberte minimálne {0} položiek!";
res.selectMaxItems = "Vyberte maximálne {0} položiek!";
res.invalidDate = "Neplatný dátum!";
res.dateIsEarly = "Dátum je neplatný! Aktuálny: {0}, Minimálne: {1}";
res.dateIsLate = "Dátum je neplatný! Aktuálny: {0}, Maximálny: {1}";
res.invalidEmail = "Neplatná emailová adresa!";
res.invalidURL = "Neplatná URL adresa!";
res.invalidCard = "Neplatný formát karty!";
res.invalidCardNumber = "Nesprávne číslo karty!";
res.invalidTextContainNumber =
    "Neplatný text! Nemôže obsahovať čísla ani špeciálne znaky";
res.invalidTextContainSpec = "Neplatný text! Nemôže obsahovať špeciálne znaky";

export const publicPath = process.env.VUE_APP_PUBLIC_PATH ? process.env.VUE_APP_PUBLIC_PATH : '/';
export const functions = {
    __getCompanyText,
};
